import { LoginPage, LogoutPage, NoAccess, SettingsPage, SignUp } from '@moveup/app-core/views';

const OrganizationsDashboard = () => import('@/views/OrganizationsDashboard.vue');
const OrganizationNew = () => import('@/views/OrganizationNew.vue');
const OrganizationEditUrls = () => import('@/views/OrganizationEditUrls.vue');

const OrganizationEditBasicInfo = () => import('@/views/OrganizationEditBasicInfo');
const OrganizationEditAssociations = () => import('@/views/OrganizationEditAssociations');
const OrganizationEditCommunication = () => import('@/views/OrganizationEditCommunication.vue');
const OrganizationAddAutomation = () => import('@/views/OrganizationAddAutomation.vue');
const OrganizationEditCareTeams = () => import('@/views/OrganizationEditCareTeams.vue');
const OrganizationEditConsents = () => import('@/views/OrganizationEditConsents.vue');
const OrganizationEditProfileFields = () => import('@/views/OrganizationEditProfileFields.vue');
const OrganizationEditTemplates =  () => import('@/views/OrganizationEditTemplates.vue');
const OrganizationTemplateList = () => import('@/views/OrganizationTemplateList.vue');
const OrganizationTemplateEdit = () => import('@/views/OrganizationTemplateEdit.vue');

import { checkAuth } from '@moveup/app-core/auth';
import OrganizationsTable from '@/views/OrganizationsTable.vue';

const routes = [
	{
		path: '/',
		redirect: '/login',
	},
	{
		path: '/login',
		name: 'Login',
		component: LoginPage,
		props: { startPage: '/organizations' },
	},
	{
		path: '/logout',
		name: 'Logout',
		component: LogoutPage,
	},
	{
		path: '/no-access',
		name: 'NoAccess',
		component: NoAccess,
		props: { name: 'Organization Admin' },
	},
	{
		path: '/signup',
		name: 'SignUp',
		component: SignUp,
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: OrganizationsDashboard,
		beforeEnter: checkAuth,
	},
	{
		path: '/organizations',
		name: 'Organizationstable',
		component: OrganizationsTable,
		beforeEnter: checkAuth,
	},
	{
		path: '/organizations/page/:page',
		name: 'Organizationstable',
		component: OrganizationsTable,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id',
		redirect: '/organization/:id/basic-info',
	},
	{
		path: '/organization/:id/basic-info',
		name: 'OrganizationEditBasicInfo',
		component: OrganizationEditBasicInfo,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/associations',
		name: 'OrganizationEditAssociations',
		component: OrganizationEditAssociations,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/urls',
		name: 'OrganizationEditUrls',
		component: OrganizationEditUrls,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/communication',
		name: 'OrganizationEditCommunication',
		component: OrganizationEditCommunication,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/automation',
		name: 'OrganizationAddCareplan',
		component: OrganizationAddAutomation,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/careteams',
		name: 'OrganizationEditCareTeams',
		component: OrganizationEditCareTeams,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/consents',
		name: 'OrganizationEditConsents',
		component: OrganizationEditConsents,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/profilefields',
		name: 'OrganizationEditProfileFields',
		component: OrganizationEditProfileFields,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization/:id/templates',
		name: 'OrganizationEditTemplates',
		component: OrganizationEditTemplates,
		beforeEnter: checkAuth,
	},
	{
		path: '/organization',
		name: 'OrganizationNew',
		component: OrganizationNew,
		beforeEnter: checkAuth,
	},
	{
		path: '/organizationtemplates',
		name: 'OrganizationTemplateList',
		component: OrganizationTemplateList,
		beforeEnter: checkAuth(['organization:read']),
	},
	{
		path: '/organizationtemplate/:id',
		name: 'OrganizationTemplateEdit',
		component: OrganizationTemplateEdit,
		beforeEnter: checkAuth(['organization:write']),
	},
	{
		path: '/organizationtemplate',
		name: 'OrganizationTemplateEdit',
		component: OrganizationTemplateEdit,
		beforeEnter: checkAuth(['organization:write']),
	},
	{
		path: '/settings',
		name: 'Settings',
		component: SettingsPage,
		beforeEnter: checkAuth,
	},
];

export default routes;
